// @flow
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';
import constants from '../../../constants';
import { processAccordingPostType } from '../../../utils/processAccordingPostType';

type responseData = {
  id?: IdType,
  author?: IdType,
  body?: string,
  mentionedUserIds?: array,
  parent?: IdType,
}
export default (partialResponse: responseData) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const userId = state.context.userId;
    const response = !!partialResponse.id && state.data.posts[partialResponse.id] ||
    {
      id: `${constants.TEMPORARY_PREFIX}${Date.now()}`,
      author: userId,
      ...partialResponse,
    };
    const author: User = state.data.users[response.author];
    const parent: Post = state.data.posts[response.parent];
    const group: Group = state.data.groups[parent.group];

    const postData = {
      ...response,
      isTemporary: true,
      hasFailed: false,
      group: group.id,
      superParent: parent.superParent || parent.id,
      superParentId: parent.superParent || parent.id,
      postTypeId: processAccordingPostType(parent, {
        blog: 2,
        answer: 19,
        reply: 19,
        poll: 7,
        question: 2,
        pollChoice: 19,
      }),
    };

    const requestBody = {
      parentId: postData.parent,
      body: postData.body,
      mentionedUserIds: postData.mentionedUserIds,
      groupCode: group.groupCode,
      parentType: parent.postTypeId,
      username: author.username,
    };

    dispatch({
      type: actionTypes.POST_RESPOND,
      data: { posts: [postData] },
    });

    let requestCompleted;
    try {
      const { payload } = await fetch(
        `post/${parent.id}/respond`,
        { method: 'POST', body: JSON.stringify(requestBody) }
      );
      requestCompleted = true;

      dispatch({
        type: actionTypes.POST_RESPOND_SUCCESS,
        isAsynchronous: true,
        data: { posts: [{ ...postData, ...payload.post, oldId: postData.id, isTemporary: false }] },
        dataToDelete: { posts: [postData] },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.POST_RESPOND_FAILURE,
        isAsynchronous: true,
        error,
        data: { posts: [{ ...postData, hasFailed: true }] },
        alert: !requestCompleted && {
          type: actionTypes.POST_RESPOND_FAILURE,
          alertType: 'warning',
          postId: postData.id,
        },
      });
    }
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/respond.js